export default __webpack_public_path__ + "static/media/tavi_mobile.15be6c26.jpg";